export function hasProperty<T extends object, K extends PropertyKey>(
    obj: T,
    prop: K
): obj is T & Record<K, any> {
    return prop in obj;
}
